"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bar_1 = __importDefault(require("./bar"));
var api_1 = __importDefault(require("./api"));
var debug_1 = __importDefault(require("debug"));
var hotkey_1 = __importDefault(require("./hotkey"));
var debug = (0, debug_1.default)("@staffbar/client:StaffBar");
/**
 *  @remarks
 *
 * The StaffBar class is the main entry point for the StaffBar SDK. It is
 * responsible for booting the SDK, register context, and requesting context
 * expansions from the server.
 *
 */
var StaffBar = /** @class */ (function () {
    /**
     *
     * Example:
     * ```ts
     * const staffbar = new StaffBar(async () => {
     *   const response = await fetch("/api/admin-token")
     *   const json = await response.json()
     *   // Assuming the response is { token: "..." }
     *   return json.token
     * })
     *
     *
     *
     * @param tokenFetcher A function that returns the JWT generated by
     * StaffBarServer().generateAuthorizationToken(userId)
     *
     * Example:
     *
     * ```ts
     * const tokenFetcher = async () => {
     *  const response = await fetch("/api/admin-token")
     *  const json = await response.json()
     *  return json.token
     * }
     * ```
     *
     * On the server, you can use the StaffBarServer().generateAuthorizationToken(userId)
     * function to generate the token.
     *
     * ```ts
     * import StaffBarServer from "@staffbar/server"
     *
     * const staffbar = new StaffBarServer({ ... })
     *
     * // Next.js API route support: https://nextjs.org/docs/api-routes/introduction
     * import type { NextApiRequest, NextApiResponse } from "next"
     *
     * type Data = {
     *  token: string
     * }
     *
     * export default async function handler(req: NextApiRequest, res: NextApiResponse<Data>) {
     *   // Do some authentication check here....
     *
     *   const token = await staffbar.generateAuthorizationToken(userId)
     *   res.status(200).json({ token })
     * }
     * ```
     *
     */
    function StaffBar(tokenFetcher, options) {
        if (options === void 0) { options = {}; }
        // The hotkey controller which manages the hotkeys
        this.hotkeyManager = null;
        // The bar controller which manages the iframe and communication with the bar
        // It's presence indicates that the bar is open
        this.barController = null;
        /**
         * What we're storing on the client which we'll send to the server
         * to expand the context
         */
        this.contextInputs = {};
        /**
         * This stores a timeout that will be used to debounce the context inputs
         */
        this.lastRefetchTimeout = null;
        this.context = undefined;
        this.bar = undefined;
        debug("constructor", tokenFetcher, options);
        this.options = options;
        this.tokenFetcher = tokenFetcher;
        this.meta = {
            url: window.location.href,
        };
        // We're using this hack to not expose the _getToken method publicly
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.api = new api_1.default({ tokenProvider: this });
        this._setup();
    }
    /**
     *
     * @param key The key that represents this context. This will be passed to the
     * backend to expand the context.
     * @param value The value that will be passed to the backend to expand the
     *
     * Example:
     *
     * ```ts
     * // client
     * window.staffbar.contextInput('userId', '12345')
     * ```
     *
     * Then on the server, you can use that userId to lookup the Stripe customer.
     *
     * ```ts
     * // server
     * staffbar.registerContextProvider('stripeCustomerId', async (clientContext: { userId?: numbers }) => {
     *  // Make sure you check to make sure the userId is available
     *   if (!clientContext.userId) {
     *     return null
     *   }
     *   const stripeCustomer = await getStripeCustomer(clientContext.userId)
     *   return { stripeCustomerId: stripeCustomer.id }
     * }
     * ```
     *
     *
     *
     */
    StaffBar.prototype.registerContext = function (key, value) {
        debug("registerContext", key, value);
        this.contextInputs[key] = value;
        this._contextInputsDidChange();
    };
    // ==============================
    // Private methods
    // ==============================
    /**
     * This is called when the StaffBar is initialized
     */
    StaffBar.prototype._setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, barResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If we're in debug mode, enable the debug messages
                        if (this.options.debug) {
                            debug_1.default.enable("@staffbar/client:*");
                        }
                        return [4 /*yield*/, this._getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            debug("_setup - no token, not rendering bar");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._refetchBar()];
                    case 2:
                        barResult = _a.sent();
                        if (!barResult.ok) {
                            debug("_setup - no bar, not rendering bar");
                            return [2 /*return*/];
                        }
                        // We can setup the hotkeys now
                        this.hotkeyManager = new hotkey_1.default({
                            key: barResult.value.userPreferences.showHotKey,
                            keyDidPress: this._handleHotKey.bind(this),
                        });
                        // Setup the bar
                        if (!barResult.value.userPreferences.barOpen) {
                            // If the bar is not open, don't do the seutp
                            return [2 /*return*/];
                        }
                        // If it is, we'll setup the bar
                        if (this.barController) {
                            this.barController.cleanup();
                        }
                        // Setup the bar
                        this.barController = this._newBarController();
                        this.barController.setup();
                        return [4 /*yield*/, Promise.all([this._refetchContext(), this._refetchBar()])];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // When the hotkey is pressed, we'll open or close the bar
    StaffBar.prototype._handleHotKey = function () {
        // If the bar is open, we'll close it
        if (this.barController) {
            this.barController.cleanup();
            this.barController = null;
            // Also set the barOpen to false in the user preferences
            // so that when the user refreshes the page, the bar will
            // not be open
            void this.api.updateUserPreferences({
                userPreferences: {
                    barOpen: false,
                },
            });
        }
        else {
            // If it's not open, we'll open it
            this.barController = this._newBarController();
            this.barController.setup();
            // Update the user preferences to indicate that the bar is open
            this._saveUserPreferences({
                barOpen: true,
            });
        }
    };
    /**
     * WARN: We use this in the API class to get the token. We don't want
     * to expose this publicly so we make it private, even thought we
     * need to use it in the API class.
     *
     * @returns  The token or null if it's not available
     */
    StaffBar.prototype._getToken = function () {
        // TODO: Add a cache here
        return this.tokenFetcher();
    };
    /**
     * This will be called when the context inputs change. It will debounce the
     * request to the server to expand the context.
     */
    StaffBar.prototype._contextInputsDidChange = function () {
        var _this = this;
        var _a;
        // Publish the client context to the bar
        (_a = this.barController) === null || _a === void 0 ? void 0 : _a.publish({
            type: "client-context-updated",
            context: this.contextInputs,
        });
        if (!this.lastRefetchTimeout) {
            this.lastRefetchTimeout = setTimeout(function () {
                _this.lastRefetchTimeout = null;
                _this._refetchContext({ force: true });
            }, 100);
        }
    };
    /**
     * This will refetch the context from the server
     *
     */
    StaffBar.prototype._refetchContext = function (_a) {
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, _e = _d.force, force = _e === void 0 ? false : _e;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        debug("_refetchContext - start");
                        if (!this.barController) {
                            // If the bar is not open, we don't need to refetch the context
                            debug("_refetchContext - bar is not open");
                            return [2 /*return*/];
                        }
                        // TODO: This is actually racey beacuse we can call multiple
                        // times before the request is cached and we'll make multiple
                        // requests. We should add a cache here.
                        if (!force && this.context && this.context.ok) {
                            // We already have the context, so we don't need to refetch it
                            // but we'll still send the context to the bar
                            debug("_refetchContext - already have context");
                            (_b = this.barController) === null || _b === void 0 ? void 0 : _b.publish({
                                type: "context-updated",
                                context: this.context.value,
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.api.getContextAndBar({
                                meta: this.meta,
                                context: this.contextInputs,
                            })];
                    case 1:
                        result = _f.sent();
                        if (!this.context && result.ok) {
                            // This is the first time we're getting the context, so we'll
                            // setup the bar
                            this.context = result;
                        }
                        debug("_refetchContext - complete", result);
                        if (!result.ok) {
                            return [2 /*return*/];
                        }
                        (_c = this.barController) === null || _c === void 0 ? void 0 : _c.publish({
                            type: "context-updated",
                            context: result.value,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Refetchs the bar config from the server
     *
     */
    StaffBar.prototype._refetchBar = function (_a) {
        var _b, _c, _d, _e;
        var _f = _a === void 0 ? {} : _a, _g = _f.force, force = _g === void 0 ? false : _g;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        debug("_refetchBar - start");
                        // TODO: This is actually racey beacuse we can call multiple
                        // times before the request is cached and we'll make multiple
                        // requests. We should add a cache here.
                        if (!force && this.bar && this.bar.ok) {
                            // We already have the bar, so we don't need to refetch it
                            // but we'll still send the bar to the bar
                            debug("_refetchBar - already have bar");
                            (_b = this.barController) === null || _b === void 0 ? void 0 : _b.publish({
                                type: "bar-config-updated",
                                bar: this.bar.value.bar,
                            });
                            (_c = this.barController) === null || _c === void 0 ? void 0 : _c.publish({
                                type: "user-preferences-updated",
                                userPreferences: this.bar.value.userPreferences,
                            });
                            return [2 /*return*/, { ok: true, value: this.bar.value }];
                        }
                        else {
                            debug("_refetchBar - fetching bar", this.bar);
                        }
                        return [4 /*yield*/, this.api.getBar()];
                    case 1:
                        result = _h.sent();
                        debug("_refetchBar - complete", result);
                        if (!result.ok) {
                            return [2 /*return*/, result];
                        }
                        this.bar = result;
                        (_d = this.barController) === null || _d === void 0 ? void 0 : _d.publish({
                            type: "bar-config-updated",
                            bar: result.value.bar,
                        });
                        (_e = this.barController) === null || _e === void 0 ? void 0 : _e.publish({
                            type: "user-preferences-updated",
                            userPreferences: __assign(__assign({}, result.value.userPreferences), { 
                                // If the bar controller is present, we know the bar is open
                                // this prevents a loop
                                barOpen: true }),
                        });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Handles the callbacks coming from the bar
     *
     * @param message The message from the bar
     */
    StaffBar.prototype._handleMessage = function (message) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, bar, result, userPreferences;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        debug("_handleMessage", message);
                        _d = message.type;
                        switch (_d) {
                            case "ping": return [3 /*break*/, 1];
                            case "open-url": return [3 /*break*/, 2];
                            case "save-bar-config": return [3 /*break*/, 3];
                            case "save-user-preferences": return [3 /*break*/, 5];
                            case "toggle-hotkey": return [3 /*break*/, 7];
                        }
                        return [3 /*break*/, 8];
                    case 1:
                        {
                            this._refetchBar();
                            this._refetchContext();
                            (_a = this.barController) === null || _a === void 0 ? void 0 : _a.publish({
                                type: "client-context-updated",
                                context: this.contextInputs,
                            });
                            return [3 /*break*/, 8];
                        }
                        _e.label = 2;
                    case 2:
                        {
                            window.open(message.url, "_blank");
                            return [3 /*break*/, 8];
                        }
                        _e.label = 3;
                    case 3:
                        bar = message.bar;
                        return [4 /*yield*/, this.api.updateBar({
                                bar: bar,
                            })];
                    case 4:
                        result = _e.sent();
                        if (result.ok && ((_b = this.bar) === null || _b === void 0 ? void 0 : _b.ok)) {
                            this.bar = {
                                ok: true,
                                value: __assign(__assign({}, (_c = this.bar) === null || _c === void 0 ? void 0 : _c.value), { bar: result.value.bar }),
                            };
                        }
                        return [3 /*break*/, 8];
                    case 5:
                        userPreferences = message.userPreferences;
                        return [4 /*yield*/, this._saveUserPreferences(userPreferences)];
                    case 6:
                        _e.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        {
                            // this._handleHotKey()
                            // We know that the bar is open, so we'll close it
                            if (this.barController) {
                                this.barController.cleanup();
                                this.barController = null;
                                // Also set the barOpen to false in the user preferences
                                // so that when the user refreshes the page, the bar will
                                // not be open
                                void this.api.updateUserPreferences({
                                    userPreferences: {
                                        barOpen: false,
                                    },
                                });
                            }
                            return [3 /*break*/, 8];
                        }
                        _e.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a new bar controller
     */
    StaffBar.prototype._newBarController = function () {
        return new bar_1.default(this._handleMessage.bind(this), {
            url: "https://bar.staffbar.com",
            // TODO: Figure out how to do this automatically, with webpack?
            // process.env.NODE_ENV === "production"
            //   ? "https://bar.staffbar.com"
            //   : "http://localhost:3000",
        });
    };
    StaffBar.prototype._saveUserPreferences = function (userPreferences) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.updateUserPreferences({
                            userPreferences: userPreferences,
                        })];
                    case 1:
                        result = _b.sent();
                        if (result.ok && ((_a = this.bar) === null || _a === void 0 ? void 0 : _a.ok)) {
                            this.bar.value = __assign(__assign({}, this.bar.value), { userPreferences: __assign(__assign({}, this.bar.value.userPreferences), result.value.userPreferences) });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return StaffBar;
}());
exports.default = StaffBar;
